<template>
  <section id="BoxMenu" ref="boxMenu">
    <div class="open" @click="openMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <nav class="sub-menu">
      <Search />
      <div class="box">
        <ul>
          <li
            @click="openMenu"
            v-for="rota in rotas"
            class="mn"
            :class="rota.name"
            v-scroll-to="'body'"
          >
            <router-link :to="rota.path ? rota.path : '/'" exact>
              <span></span>
              {{ rota.titulo }}
            </router-link>
          </li>
        </ul>
      </div>

      <SocialShare />
    </nav>
  </section>
</template>

<script>
import Search from "./Search.vue";
import SocialShare from "./SocialShare.vue";
import Vue from "vue";
let VueScrollTo = require("vue-scrollto");

Vue.use(VueScrollTo);

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

export default {
  components: {
    Search,
    SocialShare,
  },

  props: {
    rotas: {
      type: Array,
      required: true,
    },
  },

  methods: {
    openMenu($event) {
      let menu = document.getElementById("BoxMenu");
      let main = document.getElementById("main");
      let footer = document.getElementById("Footer");
      let classMenu = menu.className;
      if (classMenu == "oppenned") {
        menu.className = "";
        return;
      }
      menu.className = "oppenned";

      event.stopPropagation();
    },
  },
};
</script>

<style lang="scss">
#BoxMenu {
  .open {
    position: absolute;
    top: 50%;
    left: 30px;
    width: 50px;
    height: 50px;
    margin-top: -10px;
    display: block;
    cursor: pointer;
    z-index: 200;
    transition: all 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);

    &:hover {
      opacity: 0.8;
    }
    span {
      display: block;
      float: left;
      clear: both;
      height: 3px;
      width: 37px;
      background-color: #fff;
      overflow: hidden;
      margin-bottom: 6px;
      transition: all 0.4s ease;
    }
  }

  .sub-menu {
    background-color: #2e2e2e;
    transition: all 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    width: 285px;
    left: -285px;
    top: 0;
    bottom: 0px;
    position: fixed;
    z-index: 180;
    overflow: hidden;

    .box {
      padding: 0 35px;
      margin-top: 30px;

      .mn {
        position: relative;

        span {
          display: inline-block;
          width: 30px;
          height: 30px;
          position: absolute;
          top: 0px;
          left: 0px;
          -webkit-mask-size: 100%;
          mask-size: 100%;
          background-color: #fff;
          transition: all linear 0.2s;
        }

        &.sobre {
          span {
            -webkit-mask: url("/static/icons/storm.svg") no-repeat 0 0;
            mask: url("/static/icons/storm.svg") no-repeat 0 0;
          }
        }

        &.servicos {
          span {
            -webkit-mask: url("/static/icons/expertise.svg") no-repeat 0 0;
            mask: url("/static/icons/expertise.svg") no-repeat 0 0;
          }
        }

        &.produtos {
          span {
            -webkit-mask: url("/static/icons/produtos.svg") no-repeat 0 0;
            mask: url("/static/icons/produtos.svg") no-repeat 0 0;
          }
        }

        &.cases {
          span {
            -webkit-mask: url("/static/icons/cases.svg") no-repeat 0 0;
            mask: url("/static/icons/cases.svg") no-repeat 0 0;
          }
        }

        &.clipping {
          span {
            -webkit-mask: url("/static/icons/midia.svg") no-repeat 0 0;
            mask: url("/static/icons/midia.svg") no-repeat 0 0;
          }
        }

        &.drones {
          span {
            -webkit-mask: url("/static/icons/drones.svg") no-repeat 0 0;
            mask: url("/static/icons/drones.svg") no-repeat 0 0;
          }
        }

        &.jobs {
          span {
            -webkit-mask: url("/static/icons/jobs.svg") no-repeat 0 5px;
            mask: url("/static/icons/jobs.svg") no-repeat 0 5px;
          }
        }

        &.contato {
          span {
            border: 1px solid #ffffff;
            -webkit-mask: url("/static/icons/contato.svg") no-repeat 0 0;
            mask: url("/static/icons/contato.svg") no-repeat 0 -3px;
          }
        }

        &.blog {
          span {
            -webkit-mask: url("/static/icons/blog.svg") no-repeat 0 0;
            mask: url("/static/icons/blog.svg") no-repeat 0 0;
          }
        }

        a {
          display: block;
          color: #fff;
          font-size: 2em;
          line-height: 30px;
          height: 30px;
          margin-bottom: 25px;
          padding-left: 55px;
          transition: all linear 0.2s;

          &:hover,
          &.router-link-active {
            color: #3ab8e8;
            span {
              background-color: #3ab8e8;
            }
          }
        }
      }
    }
  }

  &.oppenned {
    .sub-menu {
      opacity: 1;
      left: 0px;
      transition: all 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    }

    .open {
      left: 300px;

      span:nth-child(2) {
        overflow: visible;
      }
      span:nth-child(1),
      span:nth-child(3) {
        z-index: 100;
        transform: rotate(45deg);
      }
      span:nth-child(1) {
        transform: rotate(45deg) translateY(1px) translateX(2px);
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        transform: rotate(-45deg) translateY(-11px) translateX(12px);
      }
    }
  }
}

@media (max-width: 400px) {
  #BoxMenu {
    .open {
      left: 15px;
      width: 35px;
      height: 35px;
      margin-top: -7px;
      span {
        zoom: 0.7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Menu.vue